// IMPORTS
//-------------------------------------------------------------------------------------------------------------------------
//Angular
import { Component, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

//Services
import { CASNavBoxService } from '../../shared/components/cas-navbox/cas-navbox-service';
import { CPDFormatters } from '../../shared/services/cpd-formatters';
import { WebServices } from '../../shared/services/webServices';
import { Helpers } from '../../shared/services/helpers';
import { casNgbDateParserFormatter } from '../../shared/services/cas-NgbDateParserFormatter';
import { FormAction } from '../../shared/classes/formAction';
import { FeatureFlagService } from '../../shared/services/featureFlagService';

//Libraries
import { BCGrowls } from '../../shared/library/bcGrowls';

//Config/Globals
import { Enums } from '../../shared/enums.js';
    
//Auth & Config
import { authToken } from '../../shared/authToken';
//import { setTimeout } from 'timers';


// EXPORTS
//-------------------------------------------------------------------------------------------------------------------------
@Component({
    template : '<div class="nrev-main-div" data-test-id="content_narrative_add">\n\n    <!--Title-->\n    <h2 tabindex="-1" class="cpd-title-div">{{_title}}</h2>\n\n    <div style="margin:0 10px 15px 20px; font-style:italic">Revising an existing narrative will create a new record for the narrative that will not become active or published until the next fiscal year rollover.</div>\n    <div style="height:10px;"></div>\n\n    <!--Content Loading -->\n    <ng-template #loading>\n        <div class="nrev-ui-content-loading">\n            <img src="public/cpd-images/loading.gif" />\n            <div style="margin-left:10px;">Loading...</div>\n        </div>\n    </ng-template>\n\n    <!--Page Content-->\n    <div *ngIf="!_isLoading(); else loading" class="nrev-ui-row" style="flex-grow:1;">\n\n        <!--Selected Practice Display-->\n        <div class="nrev-ui-cell">\n            <div class="nrev-ui-group-lbl" role="heading" aria-label="Asset"><h3>Asset</h3></div>\n            <div>\n                <span style="font-weight:bold;margin-right:5px;">Asset Code:</span><span>{{_practice?.practice_code}}</span>\n                <span style="font-weight:bold;margin:0 5px 0 20px;">Asset Name:</span><span>{{_practice?.practice_name}}</span>\n            </div>\n        </div>\n\n\n        <!--Spacer-->\n        <div style="height:30px;"></div>\n\n        <!--Narrative Details block-->\n        <div class="nrev-ui-cell" data-test-id="section_narrative_revise_details">\n            <div class="nrev-ui-group-lbl" role="heading" aria-label="Narrative Details"><h3>Narrative Details</h3></div>\n\n            <div class="cpd-ui-field-div">\n                <!-- Narrative Code -->\n                <label id="lblNarrativeCode" for="txtNarrativeCode" style="width:30px;">Code</label>\n                <input id="txtNarrativeCode"\n                       aria-labelledby="lblNarrativeCode"\n                       maxlength="10"\n                       readonly="readonly"\n                       [(ngModel)]="bm_curNarrative.practice_narrative_code"\n                       (change)="fieldChanged()"\n                       class="cpd-ui-field-readonly"\n                       style="width:100px;" />\n\n            </div>\n\n            <!--Spacer-->\n            <div style="height:10px;"></div>\n\n            <!--Current Narrative-->\n            <div>\n                <label class="off-screen" id="lblCurNarrativeText" for="txtCurNarrativeText">Current Narrative, read only</label>\n                <div>Current Narrative <span style="font-style:italic">(Read Only)</span></div>\n                <textarea id="txtCurNarrativeText"\n                          readonly="readonly"\n                          aria-labelledby="lblCurNarrativeText"\n                          [(ngModel)]="bm_curNarrative.practice_narrative"\n                          rows="20"\n                          maxlength="1999"\n                          class="cpd-ui-field-readonly"\n                          style="width:800px;"></textarea>\n            </div>\n\n            <!--Spacer-->\n            <div style="height:15px;"></div>\n\n            <!--New Narrative-->\n            <div>\n                <label class="off-screen" id="lblNewNarrativeText" for="txtNewNarrativeText">New Narrative, 2000 characters maximum</label>\n                <div>New Narrative <span style="font-style:italic">(2000 Characters Max)</span></div>\n                <textarea id="txtNewNarrativeText"\n                          aria-labelledby="lblNewNarrativeText"\n                          [(ngModel)]="bm_newNarrative.practice_narrative"\n                          (change)="fieldChanged()"\n                          (paste)="onPaste_narrativeText($event)"\n                          rows="20"\n                          maxlength="1999"\n                          style="width:800px;"></textarea>\n            </div>\n\n        </div>\n\n\n\n        <!--Popups-->\n        <!--====================================================================================================-->\n        <!--POPUP INSTANCE CONTAINER-->\n        <!--When the Modal component inserts the Angular component that wraps the Bootstrap popups, it needs to go somewhere\n        where it will be cleared when the user navigates away from this page.  Note that the popup elements inserted here\n        are moved to the \'body\' when displayed and then moved back here when not (so the heat shield/backdrop is under them in z-order).-->\n        <div id="narrative_revise_page_popups"></div>\n\n\n        <!--====================-->\n        <!-- Confirmation -->\n        <!--====================-->\n        <modal #popCancelChanges\n                containerId="narrative_revise_page_popups"\n                title="Cancel Changes"\n                label="popCancelChanges">\n\n            <!--FVT-ID-->\n            <section name="fvt_id" style="visibility:hidden;" data-test-id="dialog_narrative_revise_confirm_cancel"></section>\n\n            <!-- body -->\n            <section>\n                <div class="cpd-ui-row">\n                    <div class="cpd-ui-cell" style="width:100%">\n                        <div class="cpd-ui-field-div">\n                            Are you sure that you want to cancel your changes?\n                        </div>\n                    </div>\n                </div>\n            </section>\n\n            <!-- footer -->\n            <footer>\n                <button type="button" class="btn btn-primary" (click)="popCancelChanges.Close()">Stay on Page</button>\n                <button type="button" class="btn btn-secondary" data-dismiss="modal" (click)="navBackToList();">Discard Changes</button>\n            </footer>\n        </modal>\n\n        <!--====================-->\n        <!-- Confirmation -->\n        <!--====================-->\n        <modal #popDeleteRevisions\n                containerId="narrative_revise_page_popups"\n                title="Delete Revision"\n                label="popDeleteRevisions">\n\n            <!--FVT-ID-->\n            <section name="fvt_id" style="visibility:hidden;" data-test-id="dialog_narrative_revise_confirm_delete"></section>\n\n            <!-- body -->\n            <section>\n                <div class="cpd-ui-row">\n                    <div class="cpd-ui-cell" style="width:100%">\n                        <div class="cpd-ui-field-div">\n                            Are you sure that you want to cancel any changes and delete revisions to this narrative?\n                        </div>\n                    </div>\n                </div>\n            </section>\n\n            <!-- footer -->\n            <footer>\n                <button type="button" class="btn btn-primary" (click)="popDeleteRevisions.Close()">Cancel Delete</button>\n                <button type="button" class="btn btn-secondary" data-dismiss="modal" (click)="deleteRevisions();">Delete Revisions</button>\n            </footer>\n        </modal>\n\n\n    </div>\n\n</div>\n\n\n\n\n\n',
    styles : ['.nrev-main-div{display:flex;flex-direction:column;position:absolute;top:0px;right:0px;bottom:0px;left:0px}.nrev-ui-row{position:relative;margin:15px 0 0 0}.nrev-ui-cell{position:relative;background-color:#f0f0f0;border-radius:4px;border:solid 1px #b8b8b8;padding:25px 15px 10px 25px;margin:0 10px;max-width:900px}.nrev-ui-group-lbl{position:absolute;top:-8px;left:5px;background-color:#d4e2f2;border-radius:4px;border:solid 1px #b8b8b8;padding:1px 8px;box-shadow:1px 1px 5px rgba(0,0,0,0.3)}.nrev-ui-content-loading{display:flex;font-style:italic;margin:10px 20px}.nrev-title-div{margin:10px 8px 15px 8px;padding-bottom:4px;border-bottom:solid 1px #b8b8b8}.nrev-radio-div{display:flex;align-items:center}.nrev-field-row{display:flex;align-items:center}.nrev-field-lbl{text-align:right;margin-right:10px}'],
    providers:[ ]
})
export class NarrativeReviseComponent {

    // INPUTS/OUTPUTS/COMPONENTS
    //-------------------------------------------------------------------------------------------------------------------------
    @ViewChild('popCancelChanges') popCancelChanges;
    @ViewChild('popDeleteRevisions') popDeleteRevisions;
    
	//Class wide member reference for the growls control
	growlBox = null;


    // PRIVATE MEMBERS
    //-------------------------------------------------------------------------------------------------------------------------
    // Boiler Plater
    _allFieldsDisabled = false;
    _componentName = 'narrativeRevise.js';
    _disposalFunctions = [];
    _formName = "narrative_revise";
    _loading = true;
    _sessionStorageObject = null;
    _title = "Narratives - Edit Narrative";
    
    //BL
    _changesMade = false; //Set to true if the user changes anything
    _practiceId = null;
    _practice = null;
    _narrativeId = null;
    _originalNarrativeCode = null;

    //Bound Models
    bm_curNarrative = { practice_narrative_code:"", practice_narrative:"" };
    bm_newNarrative = { practice_narrative:"" };

    //An event listener handler method that will have "this" prebound so removeListener will work (which can't handle
    //removing a listener if it was bound in the registration)
    //_boundKeypressHandler = null;

    //Feature Flags
    //_climateSmartFeatureFlag = false;

    // INITIALIZATION/LIFECYCLE
    //-------------------------------------------------------------------------------------------------------------------------
    //==================================
    // constructor
    //==================================
    constructor(
        casNavBoxService: CASNavBoxService, 
        cpdFormatters: CPDFormatters,
        ngbDateParser: casNgbDateParserFormatter,
        helpers: Helpers,
        route:ActivatedRoute,
        router:Router,
        webServices: WebServices,
        featureFlagService: FeatureFlagService){

        this.constructor.mapParams(this, arguments);

        //Init the local storage for this page
        // (No session object yet for this page)
        //this._sessionStorageObject = this._loadSessionStorageObject();
        //if (!this._sessionStorageObject) {
        //    this._sessionStorageObject = { /*defualt values*/ }
        //    this._saveSessionStorageObject(this._sessionStorageObject);
        //}
        
        //Handle nav menu events
        //console.log("--- [constructor] Subscribing to NavBox");
        let disposable = casNavBoxService.OnActionClicked$.subscribe(action => {
            //console.log("[constructor] Firing:", action.field_name);
            this.navBoxActionClicked(action);
        })

        //console.log("---[constructor] disposable:", disposable);
        this._disposalFunctions.push(disposable);


        // Debugging
        //-------------------------------------------
        //casNavBoxService.ClearDebugEntries();
        //casNavBoxService.DebugEntries.push("Test 1");
        //let disposer = casNavBoxService.OnDebugEntryClicked$.subscribe( entry => {
        //    this._debugEntryClicked(entry);
        //});
        //this._disposalFunctions.push(disposer);

        //Keypress Handler
        //-------------------------------------------
        //Prebind the listener (not using this here, keep for later)
        //this._boundKeypressHandler = this._handleGlobalKeypress.bind(this);

        //Register the handler globally to keyup
        //window.addEventListener("keyup", this._boundKeypressHandler);
    }

    //==================================
    // ngOnDestroy
    //==================================
    ngOnDestroy(){
        //console.log("--- [ngOnDestroy] Dispose subscriptions:", this._disposalFunctions);
        this._disposalFunctions.map( x => x.unsubscribe() );
        //window.removeEventListener("keyup", this._boundKeypressHandler);
    }
    
    //==================================
    // ngOnInit
    //==================================
    ngOnInit() {
        this.set508();
        this.initalizeGrowlBox();
        this.performAsyncOperations();
        this.setNavBoxActions();
    };

    //==================================
    // initalizeGrowlBox
    //==================================
    initalizeGrowlBox() {
        this.growlBox = new BCGrowls("growlBox");
        this.growlBox.init({
            appendToElementId: "cpdesGrowlContainer" //cpdesGrowlContainer definied in \Nrcs.Cpdes.Ui\src\cpdes\components\cpdes.html
        });
    }

    //==================================
    // ngOnInit_Complete
    //==================================
    ngOnInit_Complete() {
        this._markPageAsLoading(false);
    }



    // BL FUNCTIONS
    //-------------------------------------------------------------------------------------------------------------------------
    //==================================
    // set508
    //==================================
    set508() {
        window.setTimeout(() => {
            document.getElementById("accAlertAssertive").innerText = "Loading page data";

            let el = document.getElementsByClassName("cpd-title-div")[0];
            if (el) { el.focus(); }
        }, 0);
    }

    //==================================
    // performAsyncOperations
    //==================================
    performAsyncOperations() {
        //Number of async ops this function has left to complete
        var ops = 2;

        //PRACTICE
        this.loadPractice(() => {
            if (--ops == 0) { this.ngOnInit_Complete(); }
        });

        //NARRATIVE AND REVISION
        this.loadNarrativeAndRevision(() => {
            if (--ops == 0) { this.ngOnInit_Complete(); }
        });

        //FEATUREFLAGS
        //this._loadFeatureFlags(() => {
        //    if (--ops == 0) { this.ngOnInit_Complete(); }
        //});
    }

    //==================================
    // loadPractice
    //==================================
    loadPractice(onSuccess) {
        // PARAMS
        //(note that this is a snapshot and will not change without a page reload)
        //(use rxjs if you need to react to changes. Ex: https://kamranahmed.info/blog/2018/02/28/dealing-with-route-params-in-angular-5/)
        this._practiceId = this.route.snapshot.params.practiceId;

        this.webServices.Get({
            apiPath: "/practices/getPractice",
            args: { practiceId: this._practiceId }
        })
            .then(res => {

                console.log(`[${this._componentName}:_loadData():/practices/getPractice] - res: `, res);

                if (res.data.Success) {
                    this._practice = res.data.DTO;

                    if (onSuccess) {
                        onSuccess();
                    }
                }
                else {
                    this.growlBox.addGrowl("error", "There was an error loading the asset");
                    console.log(this.cpdFormatters.formatError(res.data));
                }
            })
            .catch(err => {
                this.growlBox.addGrowl("error", "There was an error loading the asset");
                console.log(this.cpdFormatters.formatError(err));
            });
    }

    //==================================
    // loadNarrativeAndRevision
    //==================================
    //Loads the indicated narrative and it's revision narrative if available
    loadNarrativeAndRevision(onSuccess) {
        // PARAMS
        //(note that this is a snapshot and will not change without a page reload)
        //(use rxjs if you need to react to changes. Ex: https://kamranahmed.info/blog/2018/02/28/dealing-with-route-params-in-angular-5/)
        this._narrativeId = this.route.snapshot.params.narrativeId;

        //Load the current narrative and if there is one, the revision narrative
        this.webServices.Get({
            apiPath: "/narrative/getNarrativeForRevision",
            args: { narrativeId: this._narrativeId }
        })
            .then(res => {

                console.log(`[${this._componentName}:_loadData():/narrative/getNarrativeForRevision] - res:`, res);

                if (res && res.data && res.data.Success && res.data.DTO) {
                    this.setNarrativeAndRevisionData(res.data.DTO);

                    if (onSuccess) { onSuccess(); }
                }
                else {
                    this.growlBox.addGrowl("error", "There was an error loading the narrative and revision");
                    console.log(this.cpdFormatters.formatError(res.data));
                }
            })
            .catch(err => {
                this.growlBox.addGrowl("error", "There was an error loading the narrative and revision");
                console.log(this.cpdFormatters.formatError(err));
            });

    }

    //==================================
    // setNarrativeAndRevisionData
    //==================================
    setNarrativeAndRevisionData(data) {
        this.bm_curNarrative = data.currentNarrative;
        if (data.currentNarrative) {
            this._originalNarrativeCode = data.currentNarrative.practice_narrative_code;
        }
        this.bm_newNarrative = data.newNarrative || { practice_narrative: "" };//Angular can't handle models being null; not even temporarily.
   }

    //==================================
    // _loadFeatureFlags
    //==================================
    _loadFeatureFlags(fnOnComplete) {
        this.featureFlagService.getFeatureFlags()
            .then(res => {
                //this._climateSmartFeatureFlag = res;
                //console.log("this._climateSmartFeatureFlag:", this._climateSmartFeatureFlag);

                if (fnOnComplete) { fnOnComplete(); }

            })
            .catch(err => {
                this.growlBox.addGrowl("error", "There was an error loading the feature flag");
                console.log(this.cpdFormatters.formatError(err));
            });
    }

    //==================================
    // setNavBoxActions
    //==================================
    setNavBoxActions() {
        let actions = [];

        actions.push(new FormAction("act_cancel_narrative_revision", "Close"));

        switch (authToken.user.role) {

            case Enums.Roles.NHQNationalPracticeDataSteward.id:
                actions.push(new FormAction("act_discard_narrative_revision", "Delete Pending Revision"));
                actions.push(new FormAction("act_save_narrative_revision", "<u>S</u>ave Narrative", true, null, "s"));
                break;

            default:
                break;
        }

        //Tell the shared navBoxCommService what the current actions are (will update the navBox actions)
        this.casNavBoxService.Actions = actions;
        this.casNavBoxService.ActionsLoading = false;
    }

    //==================================
    // deleteRevisions
    //==================================
    deleteRevisions() {

        //If there is no revision id, then there is no DB record to delete, so just navigate back to the main list.
        if (!this.bm_newNarrative.practice_narrative_id) {
            //this.navBackToList();
            this.growlBox.addGrowl("info", "No revisions to delete."); 
            return;
        }

        this.growlBox.addGrowl("info", "Deleting revisions..."); 

        //Do the deed
        this.webServices.Post("/narrative/deleteNarrativeRevisions",
            {
                practice_narrative_id: this.bm_newNarrative.practice_narrative_id
            }
            )
            .then(res => {
                console.log("[{0}:/narrative/deleteNarrativeRevisions()] - res:".format(this._componentName), res);

                if (res.Success) {

                    //Since we no longer leave the page after save (508), we need to relead the narrative and its revision
                    this.loadNarrativeAndRevision(() => {
                        this.growlBox.addGrowl("success", "Revision deleted");
                        this._changesMade = false;
                        //Error conditions handled in the loadNarrativeAndRevision() call
                    });
                    
                }
                else {
                    this.growlBox.addGrowl("error", "There was an error deleting the revision");
                    console.log(this.cpdFormatters.formatError(res.data));
                }

            })
            .catch(err => {
                this.growlBox.addGrowl("error", "There was an error deleting the revision");
                console.log(this.cpdFormatters.formatError(err));
                this.markGridAsLoading(false);
            })   

    }

    //==================================
    // saveRevision
    //==================================
    saveRevision() {
        console.log("saveRevision()");

        try {
            this.validateRevision();
            this.growlBox.addGrowl("info", "Saving new narrative...");
            this.sendRevisionToDatabase();
        }
        catch (e) {
            console.log(this.cpdFormatters.formatError(e));
        }     
    }

    //==================================
    // validateRevision
    //==================================
    validateRevision() {
        if (!this._changesMade) {
            this.growlBox.addGrowl("error", "No changes detected for saving");
            throw "error";
        }

        if (this.bm_newNarrative.practice_narrative.trim().length < 1) {
            this.growlBox.addGrowl("error", "No narrative revision text detected for saving");
            throw "error";
        }
    }

    //==================================
    // sendRevisionToDatabase
    //==================================
    sendRevisionToDatabase() {
        this.webServices.Post("/narrative/dv1_saveNarrativeRevision",
            {
                practice_id: this._practiceId,
                practice_narrative_id: this.bm_curNarrative.practice_narrative_id, //original narrative id
                practice_narrative_code: this.bm_curNarrative.practice_narrative_code,
                original_narrative_code: this._originalNarrativeCode, 
                revision_narrative_id: this.bm_newNarrative.practice_narrative_id, //could be null, new revised narrative id
                practice_narrative: this.bm_newNarrative.practice_narrative,
                publish_mode: this.bm_newNarrative.publish_mode,
                ready_for_publish: this.bm_newNarrative.ready_for_publish
            })
            .then(res => {
                console.log(`[${this._componentName}:/narrative/dv1_saveNarrativeRevision()] - res: `, res);

                if (res.Success) {

                    //Since we no longer leave the page after save (508), we need to relead the narrative and its revision
                    this.loadNarrativeAndRevision(() => {
                        this.growlBox.addGrowl("success", "Save complete");
                        this._changesMade = false;
                        //Error conditions handled in the loadNarrativeAndRevision() call
                    });

                }
                else {
                    switch (res.ErrorCode) {

                        case "ERR-NBL-IN1":
                            this.growlBox.addGrowl("error", "Required values for new narrative are missing.");
                            break;

                        case "ERR-NBL-IN2":
                            this.growlBox.addGrowl("error", "Narrative Code already exists.");
                            break;

                        default:
                            this.growlBox.addGrowl("error", res.ErrorMessage);
                    }
                }
            })
            .catch(err => {
                this.growlBox.addGrowl("error", "There was an error saving the revision");
                console.log(this.cpdFormatters.formatError(err));
                this.markGridAsLoading(false);
            })
    }

    // UI HANDLERS
    //-------------------------------------------------------------------------------------------------------------------------
    //==================================
    // fieldChanged()
    //==================================
    fieldChanged(e) {
        this._changesMade = true;
    }

    //==================================
    // navBackToList
    //==================================
    navBackToList() {
        this.router.navigate(["/cpdes/practices/narrativesList/" + this._practiceId]);
    }

    //==================================
    // navBoxActionClicked
    //==================================
    navBoxActionClicked(action){

        console.log("[navBoxActionClicked], action:", action.field_name);

        //Make sure all "field change" events are triggered
        this.helpers.waffleFocus();

        switch( action.field_name ){
    
            //Hacked out, but not yet removed from DB
            //case "act_back_to_narratives":
            //    if (this._changesMade) {
            //        this.popCancelChanges.Open(); //Calls navBackToList() if user agrees to discard changes
            //    }
            //    else {
            //        this.navBackToList();
            //    }
            //    break;

            case "act_cancel_narrative_revision":
                if (this._changesMade) {
                    this.popCancelChanges.Open(); //Calls navBackToList() if user agrees to discard changes
                }
                else {
                    this.navBackToList();
                }
                break;

            case "act_discard_narrative_revision":
                this.popDeleteRevisions.Open();
                break;

            case "act_save_narrative_revision":
                this.saveRevision();
                break;

        }
    }

    //==================================
    // onPaste_narrativeText
    //==================================
    onPaste_narrativeText(e){
        let content = e.clipboardData.getData('text/plain');
        let length = content.length;
        if (length > 1999){
            alert("Pasted text exceeds 2000 characters.  Excess will be truncated.");
        }
    };


    // BOILER PLATE FUNCTIONS
    //-------------------------------------------------------------------------------------------------------------------------
    //==================================
    // _disableUI
    //==================================
    _disableUI(){
        this.casNavBoxService.DisableAllLinks();
        this._allFieldsDisabled = true;
    };

    //==================================
    // _enableUI
    //==================================
    _enableUI(){
        this.casNavBoxService.EnableAllLinks();
        this._allFieldsDisabled = false;
    };

    //==================================
    // _handleGlobalKeypress
    //==================================
    //_handleGlobalKeypress(e){
    //};

    //==================================
    // _isLoading
    //==================================
    _isLoading() {
        return this._loading || this.casNavBoxService.ActionsLoading;
    }

    //==================================
    // _loadSessionStorageObject
    //==================================
    //_loadSessionStorageObject() {
    //    var obj = sessionStorage.getItem(this._formName);
    //    return obj ? JSON.parse(obj) : null;
    //}

    //==================================
    // _markPageAsLoading
    //==================================
    _markPageAsLoading(isLoading) {
        this._loading = isLoading;
    }

    //==================================
    // _saveSessionStorageObject
    //==================================
    //_saveSessionStorageObject(obj) {
    //    if (!obj) { throw "[{0}:_savesessionStorageObject] - obj must not be empty".format(this._componentName) }
    //    sessionStorage.setItem(this._formName, JSON.stringify(obj));
    //}

    // DEBUGGING
    //-------------------------------------------------------------------------------------------------------------------------
    //==================================
    // _debugEntryClicked
    //==================================
    _debugEntryClicked(entry){
        console.log("[narratives:_debugEntryClicked]");
        console.log("    ", entry);

        switch (entry){ 
            case "Test 1":
                console.log("Test 1");
                //this._executeOnCondition(
                //    () => { return false; },
                //    () => { console.log("TESTING:DONE"); },
                //    100, 7
                //);
        }
    };

}
